import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["details", "summary", "label", "icon"]
    static values = {
        labelOpen: String,
        labelClose: String,
        iconClose: String,
        iconOpen: String,
        defaultState: Boolean,
    }

    initialize() {
        if (this.defaultStateValue) {
            this.detailsTarget.setAttribute("open", "true")
            this.labelTarget.innerText = this.labelCloseValue
            this.iconTarget.innerHTML = this.iconCloseValue
        } else {
            this.labelTarget.innerText = this.labelOpenValue
            this.iconTarget.innerHTML = this.iconOpenValue
        }
    }

    toggleDetails() {
        if (this.detailsTarget.open) {
            this.labelTarget.innerText = this.labelOpenValue
            this.iconTarget.innerHTML = this.iconOpenValue
        } else {
            this.labelTarget.innerText = this.labelCloseValue
            this.iconTarget.innerHTML = this.iconCloseValue
        }
    }
}
